module.exports = __webpack_public_path__ + "static/media/documents.406d68c3.svg";